import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { fixedValues } from 'src/app/shared/constants/fixed-values.enum';
import { CommonService } from '../../../services/common.service';
import { LangService } from 'src/app/core/services/lang.service';
import { DataService } from '../../../services/forms/referenc-center/data.service';
import { GridService } from 'src/app/shared/services/grid.service';

@Component({
  selector: 'app-cost-center-list',
  templateUrl: './../../../templates/forms/modals/cost-center-name-list.component.html',
})
export class CostCenterNameListComponent implements OnInit {
  @Input()
  COST_NO: any;

  @Input()
  modalShow: boolean = true;

  @Output()
  submit: EventEmitter<any> = new EventEmitter<any>();

  dataObj: any;
  parentCostCenterList: any[] = [];

  columnDefs = [];
  colObj;
  grid: any;
  gridId: string = "CostCenterNameListGrid"

  searchFields: any[] = ['P_COST_NAME', 'COST_NO'];
  public searchString;
  constructor(private apiService: DataService,
    public langService: LangService,
    public gridService: GridService) {
    this.colObj = [
      { headerName: langService.langData.costName, field: 'P_COST_NAME', sortable: true, resizable: true, hide: false },
      { headerName: langService.langData.costNo, field: 'COST_NO', sortable: true, resizable: true, hide: false },
    ];
  }


  ngOnInit() {
    this.columnDefs = this.gridService.getColumnDefs(this.colObj, this.gridId);
  }
  onGridReady(grid) {
    this.grid = grid;
    this.gridService.sizeColumnsToFit(grid, this.gridId);
    this.apiService.getParentBU()
      .subscribe(arg => { console.log(arg); this.parentCostCenterList = arg.body });
  }
  itemClick(_item) {
    this.modalShow = false;
    this.dataObj = _item;
    this.submit.next();
  }

}
